<div
  class="threshold-wrapper"
  [class.tile-saving]="tileSaving"
  [class.tile-active]="tileFocused || pendingChanges"
>
  <div class="threshold-header">
    <span class="threshold-title">{{
      remoteServiceService.getRemoteServicePrefix(
        standardUnitsThreshold.group + '__' + standardUnitsThreshold.name
      ) | translate
    }}</span>
  </div>
  <div class="threshold-content">
    <mat-form-field mat-input-height-small>
      <input
        matInput
        [formControl]="thresholdForm"
        [maxlength]="maxlengthForInput"
        (keyup)="sanitizeInput(thresholdForm.value)"
        [placeholder]="'+REMOTE_SERVICE_THRESHOLDS.INPUT_THRESHOLD' | translate"
        fieldTextContentTooltip
      />
      <span *ngIf="thresholdForm.value" mat-suffix-sticky
        ><span>{{ thresholdForm.value }}</span>
        {{ unitsAdapter.getSuffix(standardUnitsThreshold.unit) }}</span
      >
    </mat-form-field>
    <span class="threshold-description">
      {{
        '+REMOTE_SERVICE_THRESHOLDS.DESCRIPTION'
          | translate
            : {
                default: standardUnitsThreshold.default,
                min: standardUnitsThreshold.min,
                max: standardUnitsThreshold.max
              }
      }}
    </span>
    <div class="threshold-actions" *ngIf="tileFocused || pendingChanges">
      <div>
        <button
          mat-button
          appSmallButton
          gtm="onSelect"
          gtmAction="Cancel threshold"
          gtmCategory="remoteService"
          color="primary"
          (click)="cancelChanges()"
        >
          {{ 'GENERAL.BUTTON.CANCEL' | translate }}
        </button>
      </div>
      <div>
        <button
          *ngIf="latestSavedValue !== standardUnitsThreshold.default && !blockSaving"
          mat-button
          mat-stroked-button
          appSmallButton
          gtm="onSelect"
          gtmAction="Reset threshold"
          gtmCategory="remoteService"
          color="primary"
          (click)="resetToDefault()"
        >
          {{ 'GENERAL.BUTTON.RESET' | translate }}
        </button>

        <button
          mat-button
          mat-raised-button
          appSmallButton
          gtm="onSelect"
          gtmAction="Save threshold"
          gtmCategory="remoteService"
          color="primary"
          (click)="saveChanges()"
          class="save-btn"
          [disabled]="blockSaving"
        >
          <ng-container
            *ngIf="blockSaving; then btnCalculatingChanges; else btnSave"
          ></ng-container>

          <ng-template #btnCalculatingChanges>
            <mat-icon class="spin">autorenew</mat-icon>
          </ng-template>

          <ng-template #btnSave>
            {{ 'GENERAL.BUTTON.SAVE' | translate }}
          </ng-template>
        </button>
      </div>
    </div>

    <div class="threshold-actions" *ngIf="tileSaving">
      <div></div>
      <div>
        <button mat-button mat-raised-button appSmallButton color="primary">
          <mat-icon class="spin">autorenew</mat-icon>
          {{ 'GENERAL.BUTTON.SAVING' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
